import { observer } from 'mobx-react';
import MainNav from '../components/Platform/MainNav';
import Display from './Display';

function HomePage() {
  return (
    <>
      <div className="w-full z-[1]">
        <MainNav />
      </div>
      <div className="lg:pt-6 pt-3 pb-5 px-2.5 lg:px-12 w-full max-w-clientPortalMaxWidth mx-auto">
        <Display />
      </div>
    </>
  );
}

export default observer(HomePage);
